import {Mixins, Component} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import {diff} from 'jsondiffpatch'

/**
 * originalData와 비교하여 변경된 사항이 있는지 여부 handler
 * @mixin
 */
@Component
export default class ModifiedDataHandler extends Mixins(Translation) {
  originalData: any = null
  modifiedData: any = null

  get isModifiedData(): boolean {
    return Boolean(this.modifiedData)
  }

  get confirmMessageOptions() {
    const {ts} = this
    return {
      message: `변경된 ${ts('info')}가 저장되지 않았습니다. <br>계속 진행 하시겠습니까?`,
      options: {
        showClose: false,
        confirmButtonText: `${ts('confirm')}`,
        cancelButtonText: `${ts('cancel')}`,
        dangerouslyUseHTMLString: true,
      }
    }
  }

  diffData(originalData, targetData) {
    return diff(originalData, targetData)
  }

  setOriginalData(data) {
    this.originalData = JSON.parse(JSON.stringify(data))
  }
}
